import React from "react";

const DirectoryOfficers = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>A Directory of Officers And Employees</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
       
      >
        <p>
          A directory of its officers and employees.
        </p>

        <p>
         
            List of the Officers/Officials of Haryana Seeds Dev. Corpn. Limited
            as on December, 2023
          
        </p>

        <h6>PANCHKULA.</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th>S. No.</th>
                <th>
                  Name of the Officer/Official
                  <br />
                  (S/Shri/Ms.)
                </th>
                <th>Designation</th>
                <th>Residential Address</th>
                <th>Residential Phone No./Mobile</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Archana Sood</td>
                <td>Company Secretary</td>
                <td>#182,Sector-16A, Chandigarh</td>
                <td>9417553212</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Paramjit Kaur</td>
                <td>Chief Manager(P&A) (Officiating</td>
                <td>3323/71, SAS Nagar, Mohali, Punjab</td>
                <td>9872123349</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Dev Raj</td>
                <td>Chief Finance & Accounts Officer (Officiating)</td>
                <td>VPO Naraingarh, Distt. Ambala(Haryana)</td>
                <td>9416453059</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Sunil Kumar</td>
                <td>
                  Sr. M.O
                  <br />
                  (Officiating as CMM)
                </td>
                <td>Flat No.3206, GH4A, Sector-20, Panchkula, Haryana </td>
                <td>9416397488</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Harish Kumar</td>
                <td>CMP (Officiating)-cum-M(P), QCM </td>
                <td>85, Sector-9, Panchkula </td>
                <td>7988085114</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Deepak Sachdeva </td>
                <td>Senior Finance & Accounts Officer</td>
                <td>
                  Flat No. 89B, IInd Floor, Motia City, Zirakpur, Mohali
                  (Punjab)
                </td>
                <td>8168607110</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Sandeep Bhatia</td>
                <td>SPO(Veg.) –cum-M(P) (Officiating)</td>
                <td>
                  Flat No.9, Om Apartment, Friends Enclave Near Best Price,
                  Zirakpur, Mohali, Punjab
                </td>
                <td>9812318981</td>
              </tr>
              <tr>
                <td>8</td>
                <td>S.P. Kataria</td>
                <td>
                  M.O
                  <br />
                  (Officiating as Sr. M.O)
                </td>
                <td>Flat No.419, GH-2, Sector 31, Panchkula, Haryana</td>
                <td>9416315354</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Ms. Luxmi</td>
                <td>AMO</td>
                <td>79G, HSAMB Colony, Sector 14, Panchkula </td>
                <td>7082406007</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Sanjay Deewan</td>
                <td>
                  MA
                  <br />
                  (Officiating as AMO)
                </td>
                <td>
                  Tower No. 6, House No. 801, Peer Muchalla, ZirakpurTower No.
                  6, House No. 801, Peer Muchalla, Zirakpur
                </td>
                <td>7015374034</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Arun Chowdhary</td>
                <td>Accounts Officer</td>
                <td>SF-1, Aastha Dream Homes, MS-II, Dhakoli, Zirakpur </td>
                <td>9417041343</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Manmohan Krishan Sharma</td>
                <td>Assistant Secretary</td>
                <td>219, GH-110, Sector-20, Panchkula</td>
                <td>9466070493</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Sheela</td>
                <td>APO(E)</td>
                <td>163, Vasant Vihar, Phase -II, Dhakoli, Zirakpur, Punjab</td>
                <td>9464540804</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Deepak Sharma</td>
                <td>ASPO/QCI-I</td>
                <td>85,Sector-9, Panchkula</td>
                <td>8930762616</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Rajeev Kumar</td>
                <td>ASPO</td>
                <td>879, Sector-2, Panchkula</td>
                <td>8199809112</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Rohit Kumar</td>
                <td>ASPO/QCI-II</td>
                <td>H.NO.3565,SEC-46-C Chandigarh</td>
                <td>9814885599</td>
              </tr>
              <tr>
                <td>17</td>
                <td>Kavita Khatri</td>
                <td>PS (Officiating)</td>
                <td>
                  H.No.E-1/4, DLF valley, Sector-3, Kalka-Pinjore Urban State,
                  Panchkula (Haryana)
                </td>
                <td>9465446390</td>
              </tr>
              <tr>
                <td>18</td>
                <td>Bijender</td>
                <td>PA</td>
                <td>
                  20/1, Village - Kundi(Uprali) Near Gurudwara, Sector 20,
                  Panchkula
                </td>
                <td>9464040913</td>
              </tr>
              <tr>
                <td>19</td>
                <td>Jeewan Rani</td>
                <td>SO</td>
                <td>House No. 1437 (P), Sector-25, Panchkula</td>
                <td>9988821054</td>
              </tr>
              <tr>
                <td>20</td>
                <td>Meera Bai</td>
                <td>Assistant</td>
                <td>1269, Sector-10, Panchkula</td>
                <td>9463205944</td>
              </tr>
              <tr>
                <td>21</td>
                <td>Ravi Dutt</td>
                <td>Account Assistant</td>
                <td>Village Khol, Tehsil & Distt Rewari(Hry)</td>
                <td>9416172255</td>
              </tr>
              <tr>
                <td>22</td>
                <td>Vikas</td>
                <td>MA</td>
                <td>Tower No. 6, House No. 801, Peer Muchalla, Zirakpur</td>
                <td>9991110784</td>
              </tr>
              <tr>
                <td>23</td>
                <td>Dharambir</td>
                <td>MA</td>
                <td>
                  House No. 536, Gali No. 14, Haripur, Sector-4House No. 536,
                  Gali No. 14, Haripur, Sector-4
                </td>
                <td>8053987308</td>
              </tr>
              <tr>
                <td>24</td>
                <td>Chirag Singh</td>
                <td>Sr. Mech.</td>
                <td>
                  House No. 536, Gali No. 14, Haripur, Sector-4, Panchkula
                </td>
                <td>9896579468</td>
              </tr>
              <tr>
                <td>25</td>
                <td>Rajeev Verma</td>
                <td>Sr. Sc. S</td>
                <td>212-A Saini Vihar, Phase-1 Baltana</td>
                <td>9357122007</td>
              </tr>
              <tr>
                <td>26</td>
                <td>Usha Rani</td>
                <td>Sr.Sc. S</td>
                <td>2389, Tele Hos Society, Sector 50-C, Chandigarh</td>
                <td>7009858414</td>
              </tr>
              <tr>
                <td>27</td>
                <td>Ajay Khera</td>
                <td>Sr. Sc. Steno </td>
                <td>
                  Flat No.10-B, Om Apartment, Friends Enclave, Near Best Price,
                  Zirakpur{" "}
                </td>
                <td>9878134851</td>
              </tr>
              <tr>
                <td>28</td>
                <td>Vaneeta Kumari</td>
                <td>Jr. Sc. Steno</td>
                <td>
                  House No. 1460, Dadu Majra Colony, Sector-38 (WEST) Chandigarh
                </td>
                <td>9872774476</td>
              </tr>
              <tr>
                <td>29</td>
                <td>Tinku</td>
                <td>Clerk</td>
                <td>93, Bichala Nada, Sector 31, Panchkula</td>
                <td>9050922872</td>
              </tr>
              <tr>
                <td>30</td>
                <td>Ravikant</td>
                <td>Clerk</td>
                <td>1005, Gali No.11, Haripur, Sector-4, Panchkula</td>
                <td>9991360549</td>
              </tr>
              <tr>
                <td>31</td>
                <td>Nitish Gautam</td>
                <td>Clerk</td>
                <td>House No. 91, Near Military Flats, Sector-31, Panchkula</td>
                <td>8950676908</td>
              </tr>
              <tr>
                <td>32</td>
                <td>Pradeep</td>
                <td>Clerk</td>
                <td>House No. 91, Near Military Flats, Sector-31, Panchkula</td>
                <td>9817525304</td>
              </tr>
              <tr>
                <td>33</td>
                <td>Satish Kumar</td>
                <td>Clerk</td>
                <td>House No. 706, Sector-31, Panchkula</td>
                <td>9996467483</td>
              </tr>
              <tr>
                <td>34</td>
                <td>Ramesh Singh</td>
                <td>Clerk</td>
                <td>
                  Village Nada, Sector 31, Near Morni T-Point, Panchkula (H.R.)
                </td>
                <td>9914184037</td>
              </tr>
              <tr>
                <td>35</td>
                <td>Kulbir</td>
                <td>Clerk</td>
                <td>Quarter No. G-53 HMT Pinjore</td>
                <td>8813967120</td>
              </tr>
              <tr>
                <td>36</td>
                <td>Joginder</td>
                <td>Clerk</td>
                <td>
                  Flat No.-821, GH-2, Sector
                  <br />
                  31, Panchkula, Haryana
                </td>
                <td>9896538671</td>
              </tr>
              <tr>
                <td>37</td>
                <td>Vishu Panwar</td>
                <td>Clerk</td>
                <td>Flat No.406, GH-2, Sector</td>
                <td>8053281574</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>31, Panchkula, Haryana</td>
                <td></td>
              </tr>
              <tr>
                <td>38</td>
                <td>Lovjeet</td>
                <td>Clerk</td>
                <td>H.NO.1044,1F,SEC-10 Panchkula</td>
                <td>8059999790</td>
              </tr>
              <tr>
                <td>39</td>
                <td>Dalbir Singh</td>
                <td>Clerk</td>
                <td>
                  House No. 1005, Gali No. 11, Haripur, Sector 4, PanchkulaHouse
                  No. 1005, Gali No. 11, Haripur, Sector 4, Panchkula
                </td>
                <td>9309158469</td>
              </tr>
              <tr>
                <td>40</td>
                <td>Sukhdev Saini</td>
                <td>Driver</td>
                <td>Vill. Bhanu, Tehsil Barwala, Distt. Panchkula</td>
                <td>9467760546</td>
              </tr>
              <tr>
                <td>41</td>
                <td>Kamaljit Singh</td>
                <td>Driver</td>
                <td>232, Sector-10, Panchkula</td>
                <td>9803359513</td>
              </tr>
              <tr>
                <td>42</td>
                <td>Rakesh Dhull</td>
                <td>Driver</td>
                <td>164, Uparwlawas Nada Sahib, Near Sector-31, Panchkula</td>
                <td>9466520142</td>
              </tr>
              <tr>
                <td>43</td>
                <td>Bhupinder Kaur</td>
                <td>Peon</td>
                <td>502, Gali no.1, VPO Burail, Chandigarh</td>
                <td>9876795681</td>
              </tr>
              <tr>
                <td>44</td>
                <td>Ram Abhilakh</td>
                <td>Peon</td>
                <td>H.No.2660 Moli jagran Complex, Chd.</td>
                <td>9876599745</td>
              </tr>
              <tr>
                <td>45</td>
                <td>Pankaj</td>
                <td>Peon</td>
                <td>
                  Flat No.406, GH-2, Sector
                  <br />
                  31, Panchkula, Haryana
                </td>
                <td>8684831254</td>
              </tr>
              <tr>
                <td>46</td>
                <td>Shiv Rattan</td>
                <td>Peon</td>
                <td>
                  House No. 121, Laxmi Enclave, Dhakauli, Panchkula, Haryana
                </td>
                <td>9671726518</td>
              </tr>
              <tr>
                <td>47</td>
                <td>Girraj</td>
                <td>Peon</td>
                <td>Sector 31, Nada Sahib, Upper Nada, Panchkula</td>
                <td>9813894969</td>
              </tr>
              <tr>
                <td>48</td>
                <td>Vikash Kataria</td>
                <td>Peon</td>
                <td>
                  Flat No.406, GH-2, Sector
                  <br />
                  31, Panchkula, Haryana
                </td>
                <td>7015581885</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h6>YAMUNANAGAR</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th id="111" rowspan="2" scope="col">
                  S.No.
                </th>
                <th id="222" rowspan="2" scope="col">
                  Name of officers/Employee&rsquo;s
                </th>
                <th id="333" rowspan="2" scope="col">
                  Designation
                </th>
                <th id="444" rowspan="2" scope="col">
                  Residential Address
                </th>
                <th colspan="2" id="555" scope="col">
                  Telephone No.
                </th>
              </tr>
              <tr>
                <th>Office</th>
                <th>Residence</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>S.P. Singh</td>
                <td>Manager </td>
                <td>88, Near Shamshan Ghat, New Rishi Nagar, Distt. Hisar</td>
                <td>01732-250391</td>
                <td>9416388861</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Mahinder Kumar</td>
                <td>AMO</td>
                <td>Vill. Rao Majra, Tehsil Barara, Distt. Ambala</td>
                <td>01732-250391</td>
                <td>9896321464</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Ankit Sandhu</td>
                <td>ASPO</td>
                <td>VPO Barsan,Distt. Yamuna Nagar (HR)-135133</td>
                <td>01732-250391</td>
                <td>9896990340</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Anirudh Chauhan</td>
                <td>ASPO</td>
                <td>Vill. Gujjarpur, P.O. Kandhla, Distt.Shamli (UP)</td>
                <td>01732-250391</td>
                <td>8529165407</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Vishvender Singh</td>
                <td>Clerk</td>
                <td>
                  VPO Banchari, Katty Colony, Tehsil Hodal, Distt. Palwal
                  (HR)-121106
                </td>
                <td>01732-250391</td>
                <td>8198904994</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Rana Singh</td>
                <td>Sweeper</td>
                <td>293, Mishra Colony, Bypass Road Yamuna Nagar</td>
                <td>01732-250391</td>
                <td>9306115801</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h6>HISAR</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th id="11" rowspan="2" scope="col">
                  S.No.
                </th>
                <th id="22" rowspan="2" scope="col">
                  Name of officers/Employee&rsquo;s
                </th>
                <th id="33" rowspan="2" scope="col">
                  Designation
                </th>
                <th id="44" rowspan="2" scope="col">
                  Residential Address
                </th>
                <th colspan="2" id="55" scope="col">
                  Telephone No.
                </th>
              </tr>
              <tr>
                <th>Office</th>
                <th>Residence</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Mahabir Singh</td>
                <td>Regional Manager (Officiating)</td>
                <td>VPO Choudhrywas</td>
                <td>01662-275065</td>
                <td>9813854429</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Wazir Singh</td>
                <td>AMO</td>
                <td>VPO Kakrod Distt Jind Pin 126115</td>
                <td>01662-275065</td>
                <td>94667943611</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Mohan Sura</td>
                <td>AO</td>
                <td>#2406, Sector 9-11, Hisar</td>
                <td>01662-275065</td>
                <td>9416695919</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Anil Yadav</td>
                <td>SSS</td>
                <td>#1750, Sector 17, Hisar</td>
                <td>01662-275065</td>
                <td>9416093452</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Anil Dosodia </td>
                <td>Assistant </td>
                <td># 62A, Kisan Colony, Hisar</td>
                <td>01662-275065</td>
                <td>9467293264</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Sunita Kirodiwal </td>
                <td>SO</td>
                <td>Village Khedla Near Pilani Rajsthan</td>
                <td>01662-275065</td>
                <td>9468395337</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Sarita Goyal </td>
                <td>Account Assistant </td>
                <td># 09/22, Old Campus, HAU, Hisar</td>
                <td>01662-275065</td>
                <td>6280650230</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Ramniwas</td>
                <td>ASPO</td>
                <td>VPO Kirmara, Hisar 125047</td>
                <td>01662-275065</td>
                <td>9034247634</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Sunil Godara </td>
                <td>ASPO</td>
                <td>VPO Gurera, Bhiwani 127046</td>
                <td>01662-275065</td>
                <td>9813960053</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Amit</td>
                <td>ASPO</td>
                <td>VPO Surpura, Hisar</td>
                <td>01662-275065</td>
                <td>7062075910</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Rajesh Kumar</td>
                <td>Driver</td>
                <td>Dhani Shyam Lal, Hisar</td>
                <td>01662-275065</td>
                <td>9315495150</td>
              </tr>
              <tr>
                <td>12.</td>
                <td>Bantimal </td>
                <td>Clerk</td>
                <td>Village Sarsana, Hisar</td>
                <td>01662-275065</td>
                <td>9728743220</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Mohit </td>
                <td>Clerk</td>
                <td>VPO Ninan, Bhiwani</td>
                <td>01662-275065</td>
                <td>8950500224</td>
              </tr>
              <tr>
                <td>14.</td>
                <td>Ajay Kumar</td>
                <td>Clerk</td>
                <td>VPO Balak, Hisar 125112</td>
                <td>01662-275065</td>
                <td>7876225821</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Rakesh</td>
                <td>Clerk</td>
                <td>VPO Banmandari, Fatehabad</td>
                <td>01662-275065</td>
                <td>9728827956</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Ram Avtar</td>
                <td>Peon</td>
                <td>HBC Sirsa Road,Hisar</td>
                <td>01662-275065</td>
                <td>9467394227</td>
              </tr>
              <tr>
                <td>17</td>
                <td>Sabir</td>
                <td>Mali</td>
                <td>Barha Quarter Road,Hisar</td>
                <td>01662-275065</td>
                <td>9896260301</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h6>BHIWANI</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th id="1" rowspan="2" scope="col">
                  S.No.
                </th>
                <th id="2" rowspan="2" scope="col">
                  Name of officers/Employee&rsquo;s
                </th>
                <th id="3" rowspan="2" scope="col">
                  Designation
                </th>
                <th id="4" rowspan="2" scope="col">
                  Residential Address
                </th>
                <th colspan="2" id="5" scope="col">
                  Telephone No.
                </th>
              </tr>
              <tr>
                <th>Office</th>
                <th>Residence</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Lalet</td>
                <td>Marketing Officer (Officiating)</td>
                <td>Kath Mandi Near Grain Market , Bhiwani</td>
                <td>01664-242243</td>
                <td>9467396381</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Babita</td>
                <td>Section Officer</td>
                <td>12, Sector-13, Bhiwani</td>
                <td>01664-242243</td>
                <td>8607620505</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Anup Singh</td>
                <td>Marketing Assistant</td>
                <td>VPO-Makroli Kalan, Rohtak</td>
                <td>01664-242243</td>
                <td>9812121010</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Anand Goyat</td>
                <td>Marketing Assistant</td>
                <td>Goyat Pana, Near BDO Office, Meham</td>
                <td>01664-242243</td>
                <td>9034425009</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Rita Lata</td>
                <td>Clerk</td>
                <td>207, Sector-23, Bhiwani</td>
                <td>01664-242243</td>
                <td>8684011025</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Ombir</td>
                <td>Clerk</td>
                <td>503, Ambedkar Colony, Dadri Gate, Bhiwani</td>
                <td>01664-242243</td>
                <td>8221977672</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Kamla</td>
                <td>Peon</td>
                <td>VPO-Obra, Distt. Bhiwani</td>
                <td>01664-242243</td>
                <td>8396842347</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Sonia</td>
                <td>Peon</td>
                <td>VPO-Talu, Distt. Bhiwani</td>
                <td>01664-242243</td>
                <td>9817120833</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Monu</td>
                <td>Peon</td>
                <td>VPO-Sankror, Distt. Charkhi Dadri</td>
                <td>01664-242243</td>
                <td>9518829341</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Dheeraj</td>
                <td>Peon</td>
                <td>
                  412, VPO-Mokhra Kheri, Near Rajput Chopal, Distt. Rohtak
                </td>
                <td>01664-242243</td>
                <td>8684858601</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h6>UMRI</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th id="100" rowspan="2" scope="col">
                  S.No.
                </th>
                <th id="200" rowspan="2" scope="col">
                  Name of officers/Employee&rsquo;s
                </th>
                <th id="300" rowspan="2" scope="col">
                  Designation
                </th>
                <th id="400" rowspan="2" scope="col">
                  Residential Address
                </th>
                <th colspan="2" id="500" scope="col">
                  Telephone No.
                </th>
              </tr>
              <tr>
                <th>Office</th>
                <th>Residence</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td> S.P. Singh</td>
                <td>Regional Manager (Officiating)</td>
                <td>H.NO. 245, Kurukshetra</td>
                <td>01744-230339</td>
                <td>9416388861</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Suresh Pal</td>
                <td>ACCOUNT OFFICER</td>
                <td>
                  Shiv Durga Colony, Near New Anaj Mandi, Ladwa Road, Pipli,
                  Kurukshetra
                </td>
                <td>01744-230339</td>
                <td>9467587342</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Subhash Chand </td>
                <td>AMO</td>
                <td>VPO-Sultanpur, Teh. Nilokheri, Distt-Karnal</td>
                <td>01744-230339</td>
                <td>9896336201</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Rajinder Kumar</td>
                <td>STORE KEEPER</td>
                <td>VPO- Siwan, Dist- Kaithal</td>
                <td>01744-230339</td>
                <td>9466454159</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Arvind Kumar</td>
                <td>ASPO</td>
                <td>H.No. 106-P Sec-8, Kurukshetra</td>
                <td>01744-230339</td>
                <td>9466704380</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Arvind Kamboj</td>
                <td>ASPO</td>
                <td>W.No. 13 Salempur Gamri, Tehsil- Gulha, Distt.- Kaithal</td>
                <td>01744-230339</td>
                <td>8683989693</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Sachin Kumar</td>
                <td>ASPO</td>
                <td>W.No. 12, Tehsil-Indri, Distt.-Karnal</td>
                <td>01744-230339</td>
                <td>9992787055</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Gopal Singh</td>
                <td>ASPO</td>
                <td>VPO-Kaul, Teh. Dhand, Distt-Kaithal</td>
                <td>01744-230339</td>
                <td>9813584858</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Ajit Singh</td>
                <td>ASSISTANT</td>
                <td>VPO- Purkhas, Distt- Sonipat</td>
                <td>01744-230339</td>
                <td>9306847566</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Neelam</td>
                <td>A/ASSISTANT</td>
                <td>H.No. 778/7, kurukshetra</td>
                <td>01744-230339</td>
                <td>9812388558</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Vijay Kumar</td>
                <td>CLERK</td>
                <td>VPO-Gumar, Tehsil-Ganaur, Distt- Sonipat</td>
                <td>01744-230339</td>
                <td>8930003097</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Charan Singh</td>
                <td>CLERK</td>
                <td>VPO-Rahara, Tehsil- Assand, Distt- karnal</td>
                <td>01744-230339</td>
                <td>9817258968</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Sushil Kumar</td>
                <td>CLERK</td>
                <td>VPO-Keorak, Distt- Kaithal</td>
                <td>01744-230339</td>
                <td>8930882323</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Poonam</td>
                <td>CLERK</td>
                <td>VPO-Kheri Lamba, Teh-Kalayat, Distt- Kaithal</td>
                <td>01744-230339</td>
                <td>9350729837</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Nafe Singh</td>
                <td>DRIVER</td>
                <td>VPO- Kurana, Panipat</td>
                <td>01744-230339</td>
                <td>9416333198</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h6>TOHANA</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th id="10" rowspan="2" scope="col">
                  S.No.
                </th>
                <th id="20" rowspan="2" scope="col">
                  Name of officers/Employee&rsquo;s
                </th>
                <th id="30" rowspan="2" scope="col">
                  Designation
                </th>
                <th id="40" rowspan="2" scope="col">
                  Residential Address
                </th>
                <th colspan="2" id="50" scope="col">
                  Telephone No.
                </th>
              </tr>
              <tr>
                <th>Office</th>
                <th>Residence</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td> Rahuldeep Rana</td>
                <td>Manager (Officiating)</td>
                <td>#26,Chander Lane, Kamri Road, Hisar.</td>
                <td>01692-220879</td>
                <td>9991091214</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Dharmpal</td>
                <td>SR. Mech.</td>
                <td>Ward No. 12,Krishna Colony, Tohana</td>
                <td>01692-220879</td>
                <td>99918-55856</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Sanjay Kumar</td>
                <td>AMO</td>
                <td>135/9 Old Sabji Mandi, Tohana</td>
                <td>01692-220879</td>
                <td>97286-19791</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Pradeep Singh</td>
                <td>ASPO</td>
                <td>H.no. 281, ward no. 09, vpo-Pirthala, Tehsil-Tohana.</td>
                <td>01692-220879</td>
                <td>89295-29029</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Baljit Singh</td>
                <td>S/M</td>
                <td>Vpo-Balianwala, Tehsil-Tohana.</td>
                <td>01692-220879</td>
                <td>94680-94580</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Ramesh Kumar</td>
                <td>S/M</td>
                <td>Aadarash colony, Bhuna Road,Tohana.</td>
                <td>01692-220879</td>
                <td>94161-52561</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Parveen Kaur</td>
                <td>Clerk</td>
                <td>Vpo-Bhullan,Distt. Sangrur.</td>
                <td>01692-220879</td>
                <td>94679-02440</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Sanjay Kumar</td>
                <td>Clerk</td>
                <td>vpo-Nalwa, Tehsil & Distt- Hisar.</td>
                <td>01692-220879</td>
                <td>86075-76321</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Pardeep Kumar</td>
                <td>Clerk</td>
                <td>Vpo-Shamlo Kalan, Distt-Jind.</td>
                <td>01692-220879</td>
                <td>89304-93222</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Cheddi Ram</td>
                <td>Peon</td>
                <td>VPO Chatoh, Tehsil T.Salon, Distt. Amethi (U.P)</td>
                <td>01692-220879</td>
                <td>95410-71954</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Jagmohan</td>
                <td>Peon</td>
                <td>Bond Kalan, Tehsil & Distt-Bhiwani.</td>
                <td>01692-220879</td>
                <td>94661-17241</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Vikas </td>
                <td>Peon</td>
                <td>108/27, Subhash Nagar, Rohtak Road, Jind</td>
                <td>01692-220879</td>
                <td>7988516514</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h6>SIRSA</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th id="101" rowspan="2" scope="col">
                  S.No.
                </th>
                <th id="202" rowspan="2" scope="col">
                  Name of officers/Employee&rsquo;s
                </th>
                <th id="303" rowspan="2" scope="col">
                  Designation
                </th>
                <th id="404" rowspan="2" scope="col">
                  Residential Address
                </th>
                <th colspan="2" id="505" scope="col">
                  Telephone No.
                </th>
              </tr>
              <tr>
                <th>Office</th>
                <th>Residence</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td> Bharat Singh Dhaka</td>
                <td>Manager (Officiating)</td>
                <td>Vill. Mochiwali, Distt. Sirsa</td>
                <td>01666-243297</td>
                <td>
                  9468054176,
                  <br /> 7988651861
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>Jai Dev Dahiya</td>
                <td>A.O</td>
                <td>33-E/1, Professor Colony, Y. Nagar</td>
                <td>01666-243297</td>
                <td>9416119848</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Bajrang Lal</td>
                <td>AMO</td>
                <td>VPO Gujrani, Distt. Bhiwani</td>
                <td>01666-243297</td>
                <td>9992261006</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Malkeet Singh</td>
                <td>ASPO</td>
                <td>VPO Birabadi, Tehsil Ratia, Distt. Fatehabad</td>
                <td>01666-243297</td>
                <td>9915791267</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Sanju Dudi</td>
                <td>ASPO</td>
                <td>67, Friends Colony, Hisar Road, Sirsa</td>
                <td>01666-243297</td>
                <td>6375782118</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Monu</td>
                <td>Clerk</td>
                <td>VPO Dhukra, PO-Jamal Distt. Sirsa</td>
                <td>01666-243297</td>
                <td>9813585091</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Rakesh Kumar</td>
                <td>Clerk</td>
                <td>VPO Hanjira, Distt. Sirsa</td>
                <td>01666-243297</td>
                <td>9802736932</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Pooja</td>
                <td>Clerk</td>
                <td>Vill. Kani Kheri, PO Lehrian, Distt. Fatehabad</td>
                <td>01666-243297</td>
                <td>9588395536</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Daya Ram</td>
                <td>Driver</td>
                <td>138, Sant Nagar Colony, Hisar Road, Sirsa</td>
                <td>01666-243297</td>
                <td>9541411708</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Paramjeet Kaur</td>
                <td>Peon</td>
                <td>Friends Colony, Hisar Road, Sirsa</td>
                <td>01666-243297</td>
                <td>9467788796</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Satyender Parjapati</td>
                <td>Watchman</td>
                <td>Mahavir Colony, Opp. HSDC Office, Sirsa</td>
                <td>01666-243297</td>
                <td>9728468600</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h6>PATAUDI</h6>

         <div className="table-responsive">
          <table className="table table-striped table-bordered">
          
            <thead>
              <tr>
                <th id="1010" rowspan="2" scope="col">
                  S.No.
                </th>
                <th id="2020" rowspan="2" scope="col">
                  Name of officers/Employee&rsquo;s
                </th>
                <th id="3030" rowspan="2" scope="col">
                  Designation
                </th>
                <th id="4040" rowspan="2" scope="col">
                  Residential Address
                </th>
                <th colspan="2" id="5050" scope="col">
                  Telephone No.
                </th>
              </tr>
              <tr>
                <th>Office</th>
                <th>Residence</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td> Jaibir Singh</td>
                <td>Manager</td>
                <td>VPO-Jhanwari, Bhiwani</td>
                <td>0124-2672847 </td>
                <td>9992110635</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Rahul Singla</td>
                <td>Section Officer</td>
                <td>568, W.No.19, Bhatia Nagar, Tohana, Distt. Fatehabad</td>
                <td>0124-2672847</td>
                <td>9541868584</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Idrish Khan</td>
                <td>AMO</td>
                <td>
                  Vill. Malahka, PO-Tauru, Tehsil & Distt. Nuh, Hry-122105
                </td>
                <td>0124-2672847</td>
                <td>9812775950</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Hawa Singh</td>
                <td>ASO</td>
                <td>
                  Vill. Seka, PO-Mandhana, Tehsil – Narnaul, Distt. Mahendergarh
                </td>
                <td>0124-2672847</td>
                <td>9467539286</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Wasim Akram</td>
                <td>ASPO</td>
                <td>
                  Vill. Jehtana, PO-Shikrawa, Tehsil Punhana, Distt. Nuh
                  Hry-122508
                </td>
                <td>0124-2672847</td>
                <td>7988066972</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Shalini</td>
                <td>ASPO</td>
                <td>
                  Vill. Barsana, 07 Chowk Haveli, Near PNB Bank, Distt. Mathura
                  (UP)-281405
                </td>
                <td>0124-2672847</td>
                <td>6397009937</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Vinay Kumar</td>
                <td>Clerk</td>
                <td>
                  Vill. Konsiwas, PO-Majra Gurdas, Distt. & Tehsil Rewari
                  Hry-123401
                </td>
                <td>0124-2672847</td>
                <td>7404609398</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Amit Kumar</td>
                <td>Sr. Mech.</td>
                <td>
                  Vill. Mehrampur, Tehsil Narnaul, Distt. Mahendergarh Hry
                </td>
                <td>0124-2672847</td>
                <td>9416437565</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Birender Singh</td>
                <td>Peon</td>
                <td>W.No.08, Bond Kalan, Distt. Charkhi Dadri, Hry</td>
                <td>0124-2672847</td>
                <td>9992512119</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Inderjit</td>
                <td>Watchman</td>
                <td>Vill. Kishangarh Balawas, Tehsil & Distt. Rewari</td>
                <td>0124-2672847</td>
                <td>9416620169</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Tejpal</td>
                <td>Watchman</td>
                <td>Vill. Larsauli, Tehsil Ganaur, Distt. Sonepat</td>
                <td>0124-2672847</td>
                <td>9416177240</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Sanjay Kumar</td>
                <td>Peon</td>
                <td>
                  Vill. Birhera, PO-Karola, Tehsil Farrukhnagar, Distt. Gurugram
                </td>
                <td>0124-2672847</td>
                <td>9340322230</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Gaurav</td>
                <td>Peon</td>
                <td>Vill. Pinangwan, Distt. Nuh (Mewat)</td>
                <td>0124-2672847</td>
                <td>7988735390</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>
          Above lists are subject to change on promotion, transfer and
          retirement.
        </p>

        <p>Sale-counter wise list of employees is available at website.</p>
      </div>
    </div>
  );
};

export default DirectoryOfficers;
